"use strict";
/*!
 * @ganache/console.log
 *
 * @author David Murdoch
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeGetLogs = void 0;
var maybe_get_logs_1 = require("./src/maybe-get-logs");
Object.defineProperty(exports, "maybeGetLogs", { enumerable: true, get: function () { return maybe_get_logs_1.maybeGetLogs; } });
//# sourceMappingURL=index.js.map